import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import didInsert from 'webapp/modifiers/did-insert';

export default class OnboardingStepsWelcomeComponent extends Component {
	@service('onboarding') declare onboardingService: Service.Onboarding;
	@service('user-settings') declare userSettingsService: Service.UserSettings;
	@service('account') declare accountService: Service.Account;
	@service('experiment/genie-onboarding-920261')
	declare experimentGenieOnboarding920261Service: Service.Experiment.GenieOnboarding920261;

	get welcomeText() {
		let text = 'Welcome';
		if (!this.accountService.hideDataboxNotWhiteLabeledContentForNonAdmins) {
			text += ' to Databox';
		}
		return text;
	}

	@action
	setupView(node: HTMLElement): void {
		const { isEligibleForFlowB, isEligibleForFlowC } =
			this.experimentGenieOnboarding920261Service;
		if (
			this.onboardingService.isEligibleForMarketplaceSkillFlow ||
			isEligibleForFlowC ||
			isEligibleForFlowB
		) {
			void this.onboardingService.useExcelSampleFile({ skipRedirectAndDoneEvent: true });
		}

		node.style.setProperty('--welcome-text', `"${this.welcomeText}"`);

		const animationDuration = getComputedStyle(node).getPropertyValue(
			'--welcome-animation-duration',
		);
		const timeout = parseInt(animationDuration) + 2 * 1000;
		setTimeout(() => {
			this.onboardingService.nextStep();
			void this.userSettingsService.save(UserSettingsKey.ONBOARDING_WELCOME_SEEN, true);
		}, timeout);
	}
	<template>
		<div class="welcome" {{didInsert this.setupView}}>
			<span>{{this.welcomeText}}</span>
		</div>
	</template>
}
